import React from 'react';
import { Route, Switch } from 'react-router-dom';
import PrivateRoute from './PrivateRoute';
import GoToLogin from './GoToLogin';
import SignoutCallback from './SignoutCallback';
import SigninCallback from './SigninCallback';
import AjaxLoader from './AjaxLoader';
import Principale from './Principale';

export default () => (
    <AjaxLoader>
        <Switch>
            <Route path="/login" exact component={GoToLogin} />
            <Route path="/logoutCallback" component={SignoutCallback} />
            <Route path="/loginCallback" component={SigninCallback} />

            <PrivateRoute component={Principale} />
        </Switch>
    </AjaxLoader>
);